import { render, staticRenderFns } from "./absentIndex.vue?vue&type=template&id=08adb9d2&"
import script from "./absentIndex.vue?vue&type=script&lang=js&"
export * from "./absentIndex.vue?vue&type=script&lang=js&"
import style0 from "./absentIndex.vue?vue&type=style&index=0&id=08adb9d2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports